<script>
    export default {
        props: {
            value: Array,
            label: String,
            labelWidth: String,
            labelValue: [String, Number],
            labelOptions: Array,
            labelField: String,
            labelDisabled: {
                type: Boolean,
                default: false,
            },
            add: {
                type: Boolean,
                default: false,
            },
            field: String,
            clearable: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                pickerOptions:{
                    firstDayOfWeek: 1,
                    shortcuts: [
                        {
                            text: 'Сегодня',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Неделя',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Месяц',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setMonth(start.getMonth() - 1);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: 'Т. месяц',
                            onClick(picker) {
                                const end = new Date();
                                end.setMonth(end.getMonth()+1);
                                end.setDate(0);
                                const start = new Date();
                                start.setDate(1);

                                picker.$emit('pick', [start, end]);
                            }
                        },
                    ],
                }
            }
        },
        methods: {
            input_value(v) {
                this.$emit('input', v);
                if (this.field) {
                    this.$emit('input-field', {
                        field: this.field,
                        value: v,
                    });
                }
                if(v!==this.value){
                    this.$emit('change', v);
                    if (this.field) {
                        this.$emit('change-field', {
                            field: this.field,
                            value: v,
                        });
                    }
                }
            },
            change_label(v) {
                this.$emit('update:labelValue', v);
                this.$emit('change-label', v);
                if (this.labelField) {
                    this.$emit('change-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            input_label(v) {
                this.$emit('update:labelValue', v);
                if (this.labelField) {
                    this.$emit('input-label-field', {
                        field: this.field,
                        value: v,
                    });
                }
            },
            click_add() {
                this.$emit('add');
            },
        },
        computed: {
            show_append() {
                return this.show_add;
            },
            show_add() {
                if (this.disabled) return false;
                return this.add;
            },
        },
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <form-group class="form-dates" :label-width="labelWidth" :append="show_append" :label="label||(labelOptions?' ': '')">
        <el-select
                slot="labelSelect"
                v-if="labelOptions"
                :value="labelValue"
                :disabled="labelDisabled"
                @change="change_label"
                @input="input_label">
            <el-option v-for="item in labelOptions"
                       :value="item.value"
                       :label="item.label"
                       :key="item.value">
            </el-option>
        </el-select>
        <el-date-picker
                :value="value"
                @input="input_value"
                type="daterange"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :clearable="clearable"
                :disabled="disabled"
                :default-value="new Date()"
                :picker-options="pickerOptions">
        </el-date-picker>
        <el-button
                v-if="show_add"
                slot="append"
                icon="el-icon-plus"
                title="Добавить"
                @click="click_add">
        </el-button>
    </form-group>
</template>
